
import Vue from 'vue'
import { CheckoutPageModel } from '@ViewModels/CheckoutPageModel'
import { DropDownSelect } from '@/components/formGroups'
import EditAddressForm from './AddressEditForm.vue'
import { PartyStreetAddressModel } from '@ViewModels/PartyStreetAddressModel'
import { StoreCheckoutDto } from '@ViewModels/StoreCheckoutDto'
import { CheckoutStreetAddressDto } from '@ViewModels/CheckoutStreetAddressDto'

export default Vue.extend({
   name: 'BillingAddress',
   data() {
      return {
         selectedAddressId: 'new',
      }
   },
   computed: {
      modelData(): CheckoutPageModel {
         return this.$store.state.modelData
      },
      purchase(): StoreCheckoutDto {
         return this.$store.state.purchase
      },
      billingAddress(): CheckoutStreetAddressDto {
         return this.purchase.BillingAddress
      },
      addresses(): PartyStreetAddressModel[] {
         return this.$store.state.modelData.Addresses
      },
      addressOptions(): NameValuePair[] {
         const options = this.addresses.map(address => ({
            name: address.FormattedAddress,
            value: address.Id + '',
         }))
         options.push({ name: '', value: '-' })
         options.push({ name: 'Add new address', value: 'new' })
         return options
      },
      showErrors(): boolean {
         return this.$store.state.showErrors
      },
   },
   methods: {
      update() {
         const address = this.addresses.find(c => c.Id === this.selectedAddressId)
         if (address) {
            this.$store.dispatch('setBillingAddressId', this.selectedAddressId)
         }
      },
   },
   mounted() {
      if (!!this.purchase.BillingAddressId) {
         this.selectedAddressId = this.purchase.BillingAddressId
      } else if (this.modelData.Addresses.length > 0) {
         this.selectedAddressId = ''
      }
   },
   components: {
      EditAddressForm,
      DropDownSelect,
   },
})
